import { Icon } from '@manychat/manyui'

import { FlowChartContentNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentNodeHeaderBuilder'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { DEFAULT_ICON_RENDER_SIZE } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'
import { FlowChartContentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNode'
import { FlowChartContentNodeHeader } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNodeHeader'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { FlowChartStatRow } from 'common/builder/components/chart/FlowChart/types/FlowChartStatRow'

/**
 * Builder class for creating FlowChartContentNode objects.
 */
export class FlowChartContentNodeBuilder {
  private node: FlowChartContentNode

  constructor(id: string) {
    this.node = {
      id,
      type: FlowChartNodeType.CONTENT,
      nodeType: '',
      onboardingElementId: '',
      data: {
        header: new FlowChartContentNodeHeaderBuilder(
          '',
          new FlowChartIconBuilder(Icon.OrphanAction, DEFAULT_ICON_RENDER_SIZE).build(),
        ).build(),
        respondents: null,
        stats: {
          deliveredUniqueUsers: 0,
          statsTable: [],
        },
        blocks: [],
        nextSteps: [],
      },
    }
  }

  public withHeader(header: FlowChartContentNodeHeader) {
    this.node.data.header = header
    return this
  }

  public withRespondents(
    respondents: { count: number; contentId: number | undefined } | null,
  ): FlowChartContentNodeBuilder {
    this.node.data.respondents = respondents
    return this
  }

  public withDeliveredUniqueUsers(deliveredUniqueUsers: number): FlowChartContentNodeBuilder {
    this.node.data.stats.deliveredUniqueUsers = deliveredUniqueUsers
    return this
  }

  public withStatsTable(statsTable: FlowChartStatRow[]): FlowChartContentNodeBuilder {
    this.node.data.stats.statsTable = statsTable
    return this
  }

  public withBlocks(blocks: FlowChartBlock[]): FlowChartContentNodeBuilder {
    this.node.data.blocks = blocks
    return this
  }

  public withNextSteps(nextSteps: FlowChartNextStep[]): FlowChartContentNodeBuilder {
    this.node.data.nextSteps = nextSteps
    return this
  }

  public withOnboardingElementId(onboardingElementId: string): FlowChartContentNodeBuilder {
    this.node.onboardingElementId = onboardingElementId
    return this
  }

  public withNodeType(nodeType: string): FlowChartContentNodeBuilder {
    this.node.nodeType = nodeType
    return this
  }

  public build(): FlowChartContentNode {
    return this.node
  }
}
